module.exports = __webpack_public_path__ + "img/book_03.e4b57e67.jpg";